module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAATlJREFUOE+V07EuRFEQxvH/lyi2UCgUWygUEkqtUGokJAQdiQfQbqEQik0oPMIWhEZsolB4AAoJCR2dRm8LhUIyMnJyc/Y6yzlTbmZ+O3dmjgDMbBboAk/AuqQP/70kZGZTwD0wHApvgYVSzKELYK3278WYQ+/ASOIzijCH7I9ZHErayZmVQ6/A+IDkTUlnudApsJFIbkvazUE8xztaBK4SBVuSTkqgIeAZmKgVPQAzkr5yMIWD9PX7GdTjSFIrGwrYJbCcKOoALUk9M1sFjoE7YCU+2p+OAjQKPAJjCawXns8c4KPw6LuzCgqYP5cbwNGcqLA+KGDTwDXQzJGqzlLJZuYb9OE7mhP7vzqKZtYADoDtaC4p1M9jaSAUgT63vbBRx+P4BPwZdf+FaludBybDZl+Ac0lvnvMN+hhr3Wj2jYoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/image/Telephone.png
// module id = s9fY
// module chunks = 2